import { Controller } from "@hotwired/stimulus";

// The error banner of a form sent back by the server: each line names the
// fields that correct it (data-fields, a JSON list of input names). As soon
// as one of them holds a value — a text typed, a box ticked, an option
// picked — the line goes, with the error under the field; the banner goes
// with the last line. A line without fields (an error of the whole record)
// stays. The server checks everything again when the form is sent.
// A name inside a quoted attribute selector: only quotes and backslashes
// need escaping (« communication[classroom_ids][] » reads as it is).
const quoted = (name) => String(name).replace(/["\\]/g, "\\$&");

export default class extends Controller {
  static targets = ["item"];

  check(event) {
    const form = event?.target?.form || event?.target?.closest?.("form");
    if (!form) return;

    this.itemTargets.forEach((item) => {
      if (item.hidden) return;
      const names = this.fieldsOf(item);
      if (names.length === 0 || !names.some((name) => this.filled(form, name))) return;

      item.hidden = true;
      names.forEach((name) => this.clearFieldError(form, name));
    });

    if (this.itemTargets.every((item) => item.hidden)) this.element.hidden = true;
  }

  fieldsOf(item) {
    try {
      return JSON.parse(item.dataset.fields || "[]");
    } catch (_) {
      return [];
    }
  }

  // Hidden inputs (the empty value Rails sends for a list) do not count.
  filled(form, name) {
    const inputs = Array.from(form.querySelectorAll(`[name="${quoted(name)}"]`))
      .filter((input) => input.type !== "hidden");
    return inputs.some((input) => {
      if (input.type === "checkbox" || input.type === "radio") return input.checked && input.value !== "";
      return String(input.value || "").trim() !== "";
    });
  }

  // The error under a DS field, and one written apart for a list of boxes
  // (data-error-for, the name of its inputs).
  clearFieldError(form, name) {
    form.querySelectorAll(`[data-error-for="${quoted(name)}"]`).forEach((error) => { error.hidden = true; });
    form.querySelectorAll(`[name="${quoted(name)}"]`).forEach((input) => {
      const field = input.closest(".ds-field--error");
      if (!field) return;
      field.classList.remove("ds-field--error");
      field.querySelectorAll(".ds-field__error").forEach((error) => { error.hidden = true; });
    });
  }
}
